<mat-spinner *ngIf="loading" [diameter]="30"></mat-spinner>

<ng-container *ngIf="!loading">
  <ng-container [ngSwitch]="phase">
    <sbnb-add-tax *ngSwitchCase="'name'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax>

    <sbnb-add-tax-id *ngSwitchCase="'id'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax-id>

    <sbnb-add-tax-type *ngSwitchCase="'type'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax-type>

    <sbnb-add-tax-setup *ngSwitchCase="'setup'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax-setup>

    <sbnb-add-tax-duration
      *ngSwitchCase="'duration'"
      [tax$]="tax$"
      (complete)="phaseUpdate($event)"></sbnb-add-tax-duration>

    <sbnb-add-tax-calculation-type
      [tax$]="tax$"
      *ngSwitchCase="'calculation'"
      (complete)="phaseUpdate($event)"></sbnb-add-tax-calculation-type>

    <sbnb-add-tax-value *ngSwitchCase="'value'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax-value>

    <sbnb-add-tax-scope *ngSwitchCase="'scope'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax-scope>

    <sbnb-add-tax-review *ngSwitchCase="'review'" [tax$]="tax$" (complete)="phaseUpdate($event)"></sbnb-add-tax-review>

    <sbnb-add-tax-done *ngSwitchCase="'done'" (complete)="phaseUpdate($event)"></sbnb-add-tax-done>
  </ng-container>
</ng-container>
